module.exports = __webpack_public_path__ + "static/media/dad_breaking_stone.882b561b.gif";